var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"id":"topNav"}},[_c('div',{attrs:{"id":"topNavWrapper"}},[(
              _vm.$route.name == 'eventDetails' ||
              _vm.$route.name == 'practice' ||
              _vm.$route.name == 'Registration' ||
              _vm.$route.name == 'ImportRegistrants' ||
              _vm.$route.name == 'DeleteAllRegistrants' ||
              _vm.$route.name == 'ValidateAma' ||
              _vm.$route.name == 'EventClasses' ||
              _vm.$route.name == 'CreateRegistrant' ||
              _vm.$route.name == 'CreateClasses' ||
              _vm.$route.name == 'EditClasses' ||
              _vm.$route.name == 'FormClasses' ||
              _vm.$route.name == 'EventBrands' ||
              _vm.$route.name == 'ImportBrands' ||
              _vm.$route.name == 'StartGrids' ||
              _vm.$route.name == 'MyLaps' ||
              _vm.$route.name == 'SportTags' ||
              _vm.$route.name == 'RaceTimer' ||
              _vm.$route.name == 'Westhold' ||
              _vm.$route.name == 'LinkedClasses' ||
              _vm.$route.name == 'ImportClasses' ||
              _vm.$route.name == 'RegistrationSetup' ||
              _vm.$route.name == 'WaitList' ||
              _vm.$route.name == 'EventRaceList' ||
              _vm.$route.name == 'EventRaceImages' ||
              _vm.$route.name == 'EventRaceAdvanceSettings' || 
              _vm.$route.name == 'Pricing' ||
              _vm.$route.name == 'RegisteredSpectator' ||
              _vm.$route.name == 'classDivisions'
            )?_c('EventMenu',{on:{"loadTopMenuResponsive":_vm.loadTopMenuResponsive}}):_vm._e(),(_vm.$route.name == 'RegisteredSpectatorGlobal' ||
                  _vm.$route.name == 'PricingOld' ||
                  _vm.$route.name == 'PracticeOld' ||
                  _vm.$route.name == 'DivisionsOld'
                 )?_c('EventOldSiteMenu',{on:{"loadTopMenuResponsive":_vm.loadTopMenuResponsive}}):_vm._e(),(_vm.$route.name == 'Report' || _vm.$route.name == 'Serie'|| _vm.$route.name == 'CloneWaiversOld' || 
                  _vm.$route.name == 'WaiverCreate' || _vm.$route.name == 'MedicalInformation' || _vm.$route.name == 'Signed' || 
                  _vm.$route.name == 'PromoterEventLink' || _vm.$route.name == 'ImportEvent' || _vm.$route.name == 'ImportRaces' ||  
                  _vm.$route.name == 'PromoterDashboard' || _vm.$route.name == 'Workers' || _vm.$route.name == 'WorkerCreate' || 
                  _vm.$route.name == 'EventList' || _vm.$route.name == 'WaiverSign' || 
                  _vm.$route.name == 'RaceList' ||
                  _vm.$route.name == 'Profile' ||
                  _vm.$route.name == 'seriesDashboard' ||
                  _vm.$route.name == 'reportsDashboard' ||
                  _vm.$route.name == 'SerieDetails' ||
                  _vm.$route.name == 'SerieResults' ||
                  _vm.$route.name == 'CloneEventsOld' || _vm.$route.name == 'TestLayout' || _vm.$route.name == 'PaymentManager')?_c('ReportOldSiteMenu',{on:{"loadTopMenuResponsive":_vm.loadTopMenuResponsive}}):_vm._e(),(
            _vm.$route.name == 'raceDetails' ||
            _vm.$route.name == 'RaceClassesSetup' || 
            _vm.$route.name == 'RaceScoringParameters' ||
            _vm.$route.name == 'RaceParticipantsSetup')?_c('RaceMenu',{on:{"loadTopMenuResponsive":_vm.loadTopMenuResponsive}}):_vm._e(),(
              _vm.$route.name == 'raceEdit' ||
              _vm.$route.name == 'NewParticipant' ||
              _vm.$route.name == 'ParticipantScores' ||
              _vm.$route.name == 'DeleteClassScore' ||
              _vm.$route.name == 'Results' ||
              _vm.$route.name == 'QuickScore' ||
              _vm.$route.name == 'AddDNFParticipants' ||
              _vm.$route.name == 'ClearAllScores' ||
              _vm.$route.name == 'ImportScoresFromRace' ||
              _vm.$route.name == 'PhoneMonitor' ||
              _vm.$route.name == 'SectionEditor'
            )?_c('RaceEditMenu',{on:{"loadTopMenuResponsive":_vm.loadTopMenuResponsive}}):_vm._e(),(_vm.$route.name == 'SectionEditorOld' || _vm.$route.name == 'ResultsOld' || _vm.$route.name == 'ParticipantScoresOld' || 
                    _vm.$route.name == 'CreateBackupRace' || _vm.$route.name == 'ScoreAnalysis')?_c('RaceEditMenuOld',{on:{"loadTopMenuResponsive":_vm.loadTopMenuResponsive}}):_vm._e(),(_vm.$route.name == 'SectionEditor' && false)?_c('div',{staticClass:"text-center"},[_c('v-btn',{staticClass:"ma-2",attrs:{"small":"","link":"","href":"/admin/promoterDashboard"}},[_c('i',{staticClass:"far fa-tachometer"}),_vm._v(" "+_vm._s(_vm.$tc("top-menu.all.dashboard"))+" ")])],1):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }